module.exports = __webpack_public_path__ + "img/3. global plan_1.6df1796b.jpg";